import StoredLayout from 'layouts/StoredLayout';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Form, Button, Input } from 'reactstrap';
import history from '../../../../history';
import { search } from 'actions/staff/election/scrutineer/action.js';

import ReactTable from 'react-table';
import CyderReactTable from 'cyder/table/CyderReactTable';

class ListPage extends React.Component {
    constructor(props) {
        super(props);
        this.onKeywordChange = this.onKeywordChange.bind(this);
        this.search = this.search.bind(this);
        this.state = {
            list: [],
            loading: false,
            pagination: true,
            pageSize: 10,
            pageCount: 0,
        };
    }
    onKeywordChange(e) {
        this.setState({
            keyword: e.target.value,
        });
    }
    componentDidMount() {}
    search(page, pageSize, sorted, filtered) {
        this.setState({
            loading: true,
        });
        this.props
            .search(this.state.keyword, this.props.match.params.electionid, page, pageSize, sorted, filtered)
            .then(res => {
                this.setState({
                    list: res.data,
                    loading: false,
                    pageCount: res.totalNoOfPages,
                    totalNum: res.totalNoOfItems,
                });
            })
            .catch(res => {
                this.setState({
                    loading: false,
                });
            });
    }
    render() {
        const columns = [
            { Header: 'ID', maxWidth: 50, accessor: 'id', style: { whiteSpace: 'unset' } },
            { Header: 'Full Name', accessor: 'fullName', style: { whiteSpace: 'unset' } },
            { Header: 'Designation', accessor: 'designation', style: { whiteSpace: 'unset' } },
            { Header: 'Organisation Name', accessor: 'organizationName', style: { whiteSpace: 'unset' } },
            { Header: 'Email', accessor: 'email', style: { whiteSpace: 'unset' } },
            { Header: 'Secret Key', accessor: 'secretKey', style: { whiteSpace: 'unset' } },
            {
                Header: '',
                accessor: 'id',
                sortable: false,
                maxWidth: 50,
                Cell: props => {
                    return (
                        <Link to={`/staff/elections/view/${this.props.match.params.electionid}/scrutineers/${props.value}`}>
                            <Button className="ml-2 align-middle primary-btn-style">
                                <i className="mr-1 material-icons align-text-bottom ">edit</i>
                            </Button>
                        </Link>
                    );
                },
            },
        ];
        return (
            <div className="page-widget">
                <Row className="mb-2">
                    <Col xs={6} className="d-flex mb-4">
                        <Button
                            className="primary-btn-style-outline"
                            onClick={e => {
                                history.push(`/staff/elections/view/${this.props.match.params.electionid}`);
                            }}
                        >
                            <i className="material-icons align-text-bottom">chevron_left</i>
                            &nbsp; Back
                        </Button>
                    </Col>
                    <Col xs={12}>
                        <div className="form-inline">
                            <Input
                                type="text"
                                placeholder="Keyword"
                                onKeyDown={e => {
                                    if (e.keyCode == 13) this.table.fireFetchData();
                                }}
                                onChange={this.onKeywordChange}
                                value={this.state.keyword}
                            />
                            <Button className="ml-2 align-middle primary-btn-style" onClick={() => this.table.fireFetchData()}>
                                <i className="material-icons align-text-bottom">search</i>
                                &nbsp;Search
                            </Button>
                            <div className="ml-auto">
                                <Link to={`/staff/elections/view/${this.props.match.params.electionid}/scrutineers/0`}>
                                    <Button className="ml-2 align-middle primary-btn-style">
                                        <i className="material-icons align-text-bottom">add</i>
                                        &nbsp;Add
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <CyderReactTable
                            className="-highlight mb-2"
                            data={this.state.list}
                            columns={columns}
                            minRows={0}
                            filterable={false}
                            manual
                            showPagination={this.state.pagination}
                            defaultPageSize={this.state.pageSize}
                            ref={instance => {
                                if (instance != null) {
                                    this.table = instance.table;
                                }
                            }}
                            totalNum={this.state.totalNum}
                            pages={this.state.pageCount}
                            loading={this.state.loading}
                            onFetchData={(state, instance) => {
                                this.search(state.page, state.pageSize, state.sorted, state.filtered);
                            }}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        search: (keyword, electionId, page, pageSize, sorted, filtered) => {
            return dispatch(search(keyword, electionId, page, pageSize, sorted, filtered));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoredLayout(ListPage));
